<h2 mat-dialog-title>Create Variant Key</h2>

<mat-dialog-content>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Key Code</mat-label>
    <input matInput [(ngModel)]="key_code" placeholder="ex: SIZE" />
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Display Name</mat-label>
    <input matInput [(ngModel)]="display_name" placeholder="ex: Size" />
  </mat-form-field>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary"
          [disabled]="!key_code.trim() || !display_name.trim()"
          (click)="save()">
    Save
  </button>
</mat-dialog-actions>
